import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
import SelectAPI from './SelectAPI';
import Geocode from "react-geocode";

class UserVehicleCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      user: '',
      user_error: false,
      plate: '', 
      plateInvalid: false,
      vehicle_type: '', 
      vehicle_typeInvalid: false,
      loading: false,
      error_message: '',
      color_message: '',

    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
    Geocode.setApiKey(BaseService.KeyGoogleMap);
  }
  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {

      this.setState({
        plate: nextProps.editing.plate,
        vehicle_type: nextProps.editing.vehicle_type_id,
      });
    }
  }
  toggle(refresh){
    this.setState({
      user: '',
      user_error: false,
      plate: '', 
      plateInvalid: false,
      vehicle_type: '', 
      vehicle_typeInvalid: false,
      loading: false,
      error_message: '',
      color_message: '',
    });
    this.props.toggle(refresh);
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked: target.value;
    // get tag name
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  valid_field(){
    var invalid = false;
    if (this.state.plate.length<7 || this.state.plate.length>7) {
      invalid = true;
      this.setState({plateInvalid: true});
    } else {
      this.setState({plateInvalid: false});
    }
    if (this.state.vehicle_type===null || this.state.vehicle_type.length<=0) {
      invalid = true;
      this.setState({vehicle_typeInvalid: true});
    } else {
      this.setState({vehicle_typeInvalid: false});
    }

    if (this.state.user===null) {
      invalid = true;
      this.setState({user_error: true});
    }
    // Valid inputs
    if(invalid===true){
      return false;
    }
    // Success
    return true;
  }
  register() {
    if (!this.valid_field()) {
      return;
    }
    this.setState({loading: true});
    let url = BaseService.ENDPOINT + this.props.api;
    var msg_success = 'cadastrado';
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      msg_success = 'alterado';
    }

    console.log('plate ' + this.state.plate);
    console.log('type ' + this.state.vehicle_type);

    var form = new FormData();
    form.append("plate", this.state.plate);
    form.append("vehicle_type", this.state.vehicle_type.id);
          
		return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    })
		.then((response) => response.json())
		.then((json) => {
			if(json.return.code === 1){
        this.setState({
          loading: true,
          error_message: 'Usuário '+msg_success+' com sucesso!',
          color_message: 'success'
        });
      } else if(json.return.code>=300){
        window.location = '/';
      } else {
        this.setState({
          loading: true,
          error_message: json.return.message
        });
      }
		});
  }
  render() {
    console.log(this.state.vehicle_type);
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Criar')} Usuário {this.props.title}</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>Placa</Label>:'')}
                <Input
                  type="text"
                  maxLength={7}
                  name="plate"
                  placeholder="Placa"
                  value={this.state.plate}
                  onChange={this.handleInputChange}
                  invalid={this.state.plateInvalid}
                ></Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <SelectAPI
                  label={(this.props.editing!==null?"Tipo de Veículo":'')}
                  name="vehicle_type"
                  placeholder={"Selecione um Tipo de Veículo"}
                  access_token={this.props.user.access_token}
                  api={"admin/user-vehicle/type"}
                  selectedOption={this.handleInputChange}
                  value={this.state.vehicle_type}  
                  invalid={this.state.stateInvalid} 
                  formFeedbackMsg={Strings.required_field}
                  multi={false}
              />
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>

            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading} >
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={ () => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    )
  }
}
export default UserVehicleCreate;


// WEBPACK FOOTER //
// ./src/components/UserVehicleCreate.js